import React from "react";
import { useNavigate } from "react-router-dom";
import DroneImage from "./components/drones_img";
import DroneDetails from "./components/drone_details";
import UserInfo from "./components/user_info";
import DronePrice from "./components/drone_price";
import { DroneCardProps } from "../../types";

const DroneCard: React.FC<DroneCardProps> = React.memo(({
  id,
  imageUrl,
  droneName,
  location,
  timestamp,
  userName,
  pricePerDay,
  currency,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/product/${id}`);
  };

  return (
    <div
      className="bg-white rounded-2xl shadow-md overflow-hidden w-full border border-grayGlobal cursor-pointer transition-transform duration-200 hover:scale-[1.02] hover:shadow-lg flex flex-col h-full"
      onClick={handleClick}
      style={{ willChange: 'transform' }}
    >
      <div className="p-2">
        <DroneImage imageUrl={imageUrl} droneName={droneName} />
      </div>
      <DroneDetails
        droneName={droneName}
        location={location}
        timestamp={timestamp}
      />
      <div className="flex-grow" />
      {/* Sticky footer: owner always above price at card bottom */}
      <div className="flex flex-col gap-0 mt-auto p-4">
        <UserInfo userName={userName} />
        <DronePrice pricePerDay={pricePerDay} currency={currency} />
      </div>
    </div>
  );
});

export default DroneCard;
